import React, { useEffect, useState, useRef } from 'react';

import { useOutsideClick } from '../../../utils/custom-hooks';
import { titleCase } from '../../base/common/utils';
import AccountService from './account-service';

import CategoryModal from './category-modal';
import Icon from '../../ui/icon';

import './styles/form-categories.scss';

const FormCategories = ({
  label,
  value,
  setter,
  type,
  fieldErrors,
  removeCategory,
  chosenCategories,
}) => {
  const [query, setQuery] = useState('');
  const [showCategories, setShowCategories] = useState(false);
  const [categories, setCategories] = useState([]);
  const [visibleCategories, setVisibleCategories] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const ref = useRef(null);
  const suggestionsRef = useRef(null);

  useOutsideClick(suggestionsRef, () => setShowCategories(false));

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    if (fieldErrors.includes(type)) ref.current.scrollIntoView({ behavior: 'smooth' });
  }, [fieldErrors]);

  useEffect(() => {
    if (query) {
      setShowCategories(true);
    }
    if (categories.length) {
      updateVisibleCategories();
    }
  }, [query]);

  async function getCategories() {
    const res = await AccountService.getCategories();
    setCategories(res.data.data[0]);
  }

  function updateVisibleCategories() {
    const visibleCategories = categories.filter(category => {
      return (
        !chosenCategories.includes(category) && category.toLowerCase().includes(query.toLowerCase())
      );
    });
    setVisibleCategories(visibleCategories);
  }

  function highlight(text) {
    if (text.includes(query)) {
      const capitalizedText = titleCase(text);
      const splitText = capitalizedText.split('');

      const startIndex = text.indexOf(query);
      const boldedText =
        !startIndex || splitText[startIndex - 1] === ' ' ? titleCase(query) : query;

      splitText.splice(
        startIndex,
        query.length,
        <div className="suggestion-bold">{boldedText}</div>,
      );

      if (splitText[startIndex - 1] === ' ') {
        splitText.splice(startIndex - 1, 0, <div className="space"> </div>);
      }

      return splitText;
    }
    return titleCase(text);
  }

  const categoryChips = value.map(category => (
    <div className="category-chip">
      {category}
      <div onClick={() => removeCategory(category)}>
        <Icon iconName="x" size="8" />
      </div>
    </div>
  ));

  const categoryItems = showCategories
    ? visibleCategories.map((category, index) => (
        <div
          key={index}
          onClick={() => {
            setter(category);
            setQuery('');
            setShowCategories(false);
          }}
        >
          {highlight(category)}
        </div>
      ))
    : null;

  const modal = showModal ? <CategoryModal value={categories} setShowModal={setShowModal} /> : null;

  return (
    <div className={`form-categories ${fieldErrors.includes(type) ? 'errored' : ''}`} ref={ref}>
      {modal}
      <div className="form-item">
        <label>
          {label} <span className="star">*</span>
        </label>
        <div className="chips-searchbar">
          <div className="category-chips">{categoryChips}</div>
          <input
            type="text"
            className={type}
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Search..."
          />
        </div>
      </div>
      <div className="sub-line">
        <label className="spacer"></label>
        <div className="sub-line-items">
          <div className="select">Select up to 3 categories...</div>
          <div className="manage-categories" onClick={() => setShowModal(true)}>
            Manage Categories
          </div>
          <div className="suggestions" ref={suggestionsRef}>
            {categoryItems}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormCategories;
